import React from 'react';
import { Container } from 'react-bootstrap';
import Stepper from '../../../components/Stepper';
import Header from '../../../components/Header';
import ResultOptions from './components/ResultOptions';

const ResultOptionsContainer = () => {
    return(
        <React.Fragment>
            <Header />
            <Container fluid className="dap_no-padding">
                <Stepper />
                <ResultOptions />
            </Container>
        </React.Fragment>

    );
};

export default ResultOptionsContainer;